/* eslint-disable @typescript-eslint/no-unused-vars */
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { MroManualRepository } from '../../app/features/vehicles/infrastructure/mro-manual.repository';
import { VehicleMROResponseMock } from '../dataMocks/vehicle-mro-response-mock';
import { ReportingPeriodResponseMock } from '../dataMocks/reporting-period-response-mock';
import { GetVehicleMROsPaginatedResponse, ReportingPeriodResponse, VehicleMROResponse } from '../../app/features/vehicles/domain/mro-manual-model';

export class MroManualApiServiceMock implements MroManualRepository {
    createVehicleMRO(vehicleId: string, miles: number, odometerPhoto?: File): Observable<VehicleMROResponse> {
        return of({...VehicleMROResponseMock});
    }

    deleteVehicleMRO(vehicleId: string, miles: number, odometerPhoto: File): Observable<void> {
        return of(void 0);
    }

    getCurrentReportingPeriod(): Observable<ReportingPeriodResponse> {
        return of({...ReportingPeriodResponseMock});
    }

    getVehicleMROById(vehicleId: string): Observable<VehicleMROResponse> {
        return of({...VehicleMROResponseMock});
    }

    getVehicleMROsByUserId(page = 1, size = 10): Observable<GetVehicleMROsPaginatedResponse> {
        return of({
            content: [{...VehicleMROResponseMock}],
            pagination: {
                currentPage: page,
                pageSize: size,
                totalElements: 1,
                totalPages: 1,
            },
        });
    }

    recordOdometerReading(vehicleId: string, miles: number, odometerPhoto: File): Observable<void> {
        return of(void 0);
    }
}
